import React from 'react';
import ChatWindow from '../components/ChatWindow';

const ChatPage: React.FC = () => {
  return (
    <div style={{ height: '100vh', display: 'flex' }}>
      <ChatWindow />
    </div>
  );
};

export default ChatPage;
